module.exports = __webpack_public_path__ + "img/classroom_active.f13d64cc.png";